function noLatinLettersValidator(value = '') {
  let isValid

  const { path, createError } = this

  if (value?.length === 0) {
    return true
  }

  const urlPattern = new RegExp('[a-zA-Z]', 'g') // Has latin letters

  isValid = !urlPattern.test(value)

  return (
    isValid ||
    createError({
      path,
      message: 'common::validation_messages.no_latin_letters',
    })
  )
}

export default noLatinLettersValidator
